const queryString = (params: object) => {
    return Object.keys(params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key as keyof object])
    }).join('&');
}

export default queryString;
